import React from "react";

import FeaturesScreen from "@/components/screens/Features.component";
import PartnersScreen from "@/components/screens/PartnersScreen.component";
import VideoScreen from "@/components/screens/VideoScreen.component";
import WhatWeDoScreen from "@/components/screens/WhatWeDoScreen.component";

import DocumentComponent from "../components/Document.component";
import ScheduleComponent from "../components/Schedule.component";
import IntroScreen from "../components/screens/intro.components";
import PakVertScreen from "../components/screens/PakVert.component";
import SignatureModelsScreen from "../components/screens/SignatureModels.component";
import i18n from "../i18n";

const Home = () => {
  const { t } = i18n;

  const description = t(
    "PakVille™ designs and manufactures next-generation modular buildings using its proprietary PakVert™ engineered panels, made from 100% recycled materials. These all-in-one panels replace traditional framing, insulation, vapor barriers, drywall, and exterior sheathing, making construction faster, affordable, and sustainable.",
  );

  const alternates = [
    { hreflang: "en", href: "/" },
    { hreflang: "fr", href: "/fr/" },
    { hreflang: "x-default", href: "/" },
  ];

  const siteUrl = "https://pakville.ca";
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "PakVille™",
    legalName: "PakVille™ Construction Corp",
    url: siteUrl,
    logo: `${siteUrl}/images/logo/pakville.png`,
    description,
    address: {
      "@type": "PostalAddress",
      streetAddress: "618 Av. Meloche",
      addressLocality: "Dorval",
      addressRegion: "QC",
      postalCode: "H9P 2P4",
      addressCountry: "CA",
    },
    contactPoint: {
      "@type": "ContactPoint",
      email: "info@pakville.ca",
      contactType: "sales",
      areaServed: "CA",
      availableLanguage: ["English", "French"],
    },
    sameAs: [
      "https://www.youtube.com/channel/UCOETzq4CMluyhH87DrwMW5g",
      "https://www.facebook.com/profile.php?id=61552975003426",
      "https://www.instagram.com/pakville",
      "https://www.linkedin.com/company/pakville",
    ],
  };

  return (
    <React.Fragment>
      <DocumentComponent
        alternates={alternates}
        description={description}
        jsonLd={jsonLd}
        title=""
      />

      <VideoScreen />

      <IntroScreen />

      <WhatWeDoScreen />

      <SignatureModelsScreen />

      <PakVertScreen />

      <PartnersScreen />

      <FeaturesScreen />

      <ScheduleComponent />
    </React.Fragment>
  );
};

export default Home;
